module.exports = __webpack_public_path__ + "img/logo_small_white.3b55061c.svg";